import React, { useState, useEffect } from 'react';
import CodeEditor from './CodeEditor';
import ChatPanel from './ChatPanel';
import FileTree from './FileTree';
import Preview from './Preview';
import { aiAPI } from '../../services/ai-api.js';
import { Loader2 } from 'lucide-react';

function AIBuilderIDE({ projectId }) {
  const [project, setProject] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProject = async () => {
      try {
        const projectData = await aiAPI.getProject(projectId);
        const files = projectData.files || [];
        setProject({
          id: projectData.id,
          name: projectData.name,
          port: projectData.port,
          files,
        });
        if (files.length > 0) {
          setSelectedFile(files[0]);
        }
        setLoading(false);
      } catch (error) {
        console.error('Failed to load project:', error);
        setLoading(false);
      }
    };

    loadProject();
  }, [projectId]);

  const handleChatMessage = async (message) => {
    const response = await aiAPI.sendMessage(projectId, message);
    if (project) {
      const files = response.files || [];
      setProject({ ...project, files });
      if (files.length > 0) {
        setSelectedFile(files[0]);
      }
    }
    return response;
  };

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-900">
        <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
      </div>
    );
  }

  if (!project) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-900 text-white">
        <p>Project not found</p>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col bg-gray-900 text-white">
      <div className="h-12 bg-gray-800 border-b border-gray-700 flex items-center px-4">
        <h1 className="text-lg font-semibold">{project.name}</h1>
        <div className="ml-auto flex items-center gap-2">
          <div className="px-2 py-1 bg-green-500/20 text-green-400 rounded text-xs">
            AI Builder
          </div>
        </div>
      </div>

      <div className="flex-1 flex overflow-hidden">
        <div className="w-64 bg-gray-800 border-r border-gray-700 overflow-y-auto">
          <FileTree
            files={project.files}
            selectedFile={selectedFile}
            onSelect={setSelectedFile}
          />
        </div>

        <div className="flex-1 flex flex-col">
          <CodeEditor file={selectedFile} />
        </div>

        <div className="w-96 border-l border-gray-700 flex flex-col">
          <div className="h-1/2 border-b border-gray-700">
            <Preview port={project.port} />
          </div>
          <div className="h-1/2">
            <ChatPanel onMessage={handleChatMessage} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AIBuilderIDE;
